module.exports = __webpack_public_path__ + "img/03-2.5b90225f.png";